// react-redux imports
import { useSelector } from "react-redux";
import { RootState } from "app/store";

// common imports
import FlexColumn from "common/components/styled-components/FlexColumn";

// styled-components imports
import Box from "./styled-components/Box";
import BoxButton from "./styled-components/BoxButton";
import BoxTitle from "./styled-components/BoxTitle";
import SectionDescription from "../styled-components/SectionDescription";

import StackedBar from "../StackedBar";

interface EnergyProps {
  averageFootprint: number;
  userFootprint: number;
  averageSectorFootprint: number;
  userSectorFootprint: number;
}

function Energy({
  averageFootprint,
  userFootprint,
  averageSectorFootprint,
  userSectorFootprint,
}: EnergyProps) {
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );

  function handleSimulation() {
    let url = process.env.REACT_APP_SIMULATION_URL
    window.open(url)
  }

  return (
    <FlexColumn gap={upDesktopScreen ? 20 : 24}>
      <StackedBar
        title="Energía"
        averageColor="#306ba5"
        averageValue={averageSectorFootprint}
        userColor="#809fdb"
        userValue={userSectorFootprint}
        total={Math.max(averageFootprint, userFootprint)}
      />
      <SectionDescription>
        Existen muchas maneras de optimizar nuestro consumo energético y su
        impacto: Desde cambiar nuestra iluminación por una de bajo consumo
        (reduciendo hasta un 75% su consumo), hasta la instalación de un
        termóstato inteligente para optimizar la temperatura en las distintas
        franjas horarias. Sin embargo, la transición a fuentes de energía
        renovables será la medida con mayor impacto en la reducción de nuestra
        huella de carbono.
      </SectionDescription>

      <Box>
        <BoxTitle>En Digien, ¡te ayudamos a dar el paso!</BoxTitle>
        <BoxButton onClick={handleSimulation}>
          Simula tu instalación fotovoltáica
        </BoxButton>
      </Box>
    </FlexColumn>
  );
}

export default Energy;
